module.exports = __webpack_public_path__ + "img/smartpoint-logo.0f533d83.svg";